<div class="select-all">
  <app-checkbox class="select-all__checkbox">
    <input type="checkbox" [formControl]="control" (change)="handleSelectAll($event)" />
  </app-checkbox>
  <a (click)="deleted.emit()" class="link link--dotted-blue-dark select-all__link">{{ label }}</a>
</div>
